module.exports = __webpack_public_path__ + "static/media/18ECA20.6c487f49.jpg";